import React from 'react';
import '../styles/terms.css';

const Subprocessors = ({ onClose }) => {
    return (
        <div className="modal">
            <div className="modal-content terms-section">
                <span className="close" onClick={onClose}>&times;</span>
                <h1>List of Subprocessors</h1>
                <p>Last Updated: Sat Aug 23, 2025</p>
                <p>This page provides a comprehensive list of third-party subprocessors that Intellommerce ("we", "us", "our") uses to provide our automated digital transformation services. These subprocessors may process personal data on our behalf as part of our service delivery.</p>

                <h2>Notification of Changes</h2>
                <p>We will update this list when we add or remove subprocessors. Enterprise customers with Data Processing Agreements (DPAs) will receive 30 days advance notice of material changes via email. If you object to a new subprocessor, please contact us at privacy@intellommerce.ai within 14 days of notification.</p>

                <h2>Infrastructure and Hosting Providers</h2>
                <table>
                    <tr>
                        <th>Subprocessor</th>
                        <th>Purpose</th>
                        <th>Data Processed</th>
                        <th>Location</th>
                        <th>Certifications</th>
                    </tr>
                    <tr>
                        <td><strong>Amazon Web Services (AWS)</strong></td>
                        <td>Cloud infrastructure, computing, storage</td>
                        <td>All customer data hosted on platform</td>
                        <td>USA, EU (Frankfurt, Ireland), Asia-Pacific (Singapore, Sydney)</td>
                        <td>ISO 27001, SOC 2, PCI DSS, HIPAA</td>
                    </tr>
                    <tr>
                        <td><strong>Google Cloud Platform</strong></td>
                        <td>Secondary cloud infrastructure, ML services</td>
                        <td>Data processing, analytics workloads</td>
                        <td>USA, EU (Belgium, Netherlands), Asia</td>
                        <td>ISO 27001, SOC 2, PCI DSS</td>
                    </tr>
                    <tr>
                        <td><strong>Microsoft Azure</strong></td>
                        <td>Backup infrastructure, disaster recovery</td>
                        <td>Backup data, system configurations</td>
                        <td>USA, EU, Asia-Pacific</td>
                        <td>ISO 27001, SOC 2, HIPAA</td>
                    </tr>
                    <tr>
                        <td><strong>Cloudflare</strong></td>
                        <td>CDN, DDoS protection, DNS services</td>
                        <td>Traffic data, IP addresses, cached content</td>
                        <td>Global (150+ locations)</td>
                        <td>ISO 27001, SOC 2</td>
                    </tr>
                </table>

                <h2>Data Processing and Analytics</h2>
                <table>
                    <tr>
                        <th>Subprocessor</th>
                        <th>Purpose</th>
                        <th>Data Processed</th>
                        <th>Location</th>
                        <th>Certifications</th>
                    </tr>
                    <tr>
                        <td><strong>Databricks</strong></td>
                        <td>Big data processing, ML platform</td>
                        <td>Customer datasets for processing</td>
                        <td>USA, EU</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Snowflake</strong></td>
                        <td>Data warehouse services</td>
                        <td>Structured data, analytics data</td>
                        <td>USA, EU, Asia</td>
                        <td>SOC 2, HIPAA, PCI DSS</td>
                    </tr>
                    <tr>
                        <td><strong>Elasticsearch</strong></td>
                        <td>Search and analytics engine</td>
                        <td>Logs, search indices, metadata</td>
                        <td>USA, EU</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                </table>

                <h2>Communication and Support Services</h2>
                <table>
                    <tr>
                        <th>Subprocessor</th>
                        <th>Purpose</th>
                        <th>Data Processed</th>
                        <th>Location</th>
                        <th>Certifications</th>
                    </tr>
                    <tr>
                        <td><strong>SendGrid (Twilio)</strong></td>
                        <td>Transactional email delivery</td>
                        <td>Email addresses, email content</td>
                        <td>USA</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Twilio</strong></td>
                        <td>SMS notifications, voice services</td>
                        <td>Phone numbers, message content</td>
                        <td>USA, EU</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Zendesk</strong></td>
                        <td>Customer support ticketing</td>
                        <td>Support tickets, customer communications</td>
                        <td>USA, EU</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Intercom</strong></td>
                        <td>Customer messaging, chat support</td>
                        <td>Chat logs, user profiles</td>
                        <td>USA, EU</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Slack</strong></td>
                        <td>Internal team communication</td>
                        <td>Internal discussions about customer issues</td>
                        <td>USA</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                </table>

                <h2>Payment Processing</h2>
                <table>
                    <tr>
                        <th>Subprocessor</th>
                        <th>Purpose</th>
                        <th>Data Processed</th>
                        <th>Location</th>
                        <th>Certifications</th>
                    </tr>
                    <tr>
                        <td><strong>Stripe</strong></td>
                        <td>Payment processing, billing</td>
                        <td>Payment information, billing addresses</td>
                        <td>USA, EU</td>
                        <td>PCI DSS Level 1, SOC 2</td>
                    </tr>
                    <tr>
                        <td><strong>PayPal</strong></td>
                        <td>Alternative payment processing</td>
                        <td>Payment information, email addresses</td>
                        <td>USA, EU, Asia</td>
                        <td>PCI DSS, SOC 2</td>
                    </tr>
                    <tr>
                        <td><strong>Chargebee</strong></td>
                        <td>Subscription management</td>
                        <td>Subscription data, billing information</td>
                        <td>USA, EU</td>
                        <td>PCI DSS, SOC 2</td>
                    </tr>
                </table>

                <h2>Security and Monitoring</h2>
                <table>
                    <tr>
                        <th>Subprocessor</th>
                        <th>Purpose</th>
                        <th>Data Processed</th>
                        <th>Location</th>
                        <th>Certifications</th>
                    </tr>
                    <tr>
                        <td><strong>Auth0 (Okta)</strong></td>
                        <td>Authentication services</td>
                        <td>User credentials, authentication tokens</td>
                        <td>USA, EU</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Datadog</strong></td>
                        <td>Application monitoring, logging</td>
                        <td>Application logs, performance metrics</td>
                        <td>USA, EU</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Sentry</strong></td>
                        <td>Error tracking and monitoring</td>
                        <td>Error logs, stack traces</td>
                        <td>USA</td>
                        <td>SOC 2</td>
                    </tr>
                    <tr>
                        <td><strong>CrowdStrike</strong></td>
                        <td>Endpoint detection and response</td>
                        <td>Security events, threat intelligence</td>
                        <td>USA</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>1Password Business</strong></td>
                        <td>Secrets management</td>
                        <td>Encrypted credentials</td>
                        <td>Canada, EU</td>
                        <td>SOC 2</td>
                    </tr>
                </table>

                <h2>Analytics and Business Intelligence</h2>
                <table>
                    <tr>
                        <th>Subprocessor</th>
                        <th>Purpose</th>
                        <th>Data Processed</th>
                        <th>Location</th>
                        <th>Certifications</th>
                    </tr>
                    <tr>
                        <td><strong>Google Analytics</strong></td>
                        <td>Website analytics</td>
                        <td>Anonymized usage data, cookies</td>
                        <td>USA</td>
                        <td>ISO 27001, SOC 2</td>
                    </tr>
                    <tr>
                        <td><strong>Mixpanel</strong></td>
                        <td>Product analytics</td>
                        <td>User behavior data, feature usage</td>
                        <td>USA, EU</td>
                        <td>SOC 2, GDPR compliant</td>
                    </tr>
                    <tr>
                        <td><strong>Segment</strong></td>
                        <td>Customer data platform</td>
                        <td>Event data, user attributes</td>
                        <td>USA</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Tableau (Salesforce)</strong></td>
                        <td>Business intelligence visualization</td>
                        <td>Aggregated business metrics</td>
                        <td>USA</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                </table>

                <h2>Development and Collaboration Tools</h2>
                <table>
                    <tr>
                        <th>Subprocessor</th>
                        <th>Purpose</th>
                        <th>Data Processed</th>
                        <th>Location</th>
                        <th>Certifications</th>
                    </tr>
                    <tr>
                        <td><strong>GitHub</strong></td>
                        <td>Source code management</td>
                        <td>Code repositories, issue tracking</td>
                        <td>USA</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>GitLab</strong></td>
                        <td>CI/CD pipeline, code review</td>
                        <td>Code, build artifacts</td>
                        <td>USA, EU</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Jira (Atlassian)</strong></td>
                        <td>Project management</td>
                        <td>Project data, customer requirements</td>
                        <td>USA, EU, Australia</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Confluence (Atlassian)</strong></td>
                        <td>Documentation platform</td>
                        <td>Technical documentation, knowledge base</td>
                        <td>USA, EU, Australia</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                </table>

                <h2>Marketing and Sales Tools</h2>
                <table>
                    <tr>
                        <th>Subprocessor</th>
                        <th>Purpose</th>
                        <th>Data Processed</th>
                        <th>Location</th>
                        <th>Certifications</th>
                    </tr>
                    <tr>
                        <td><strong>HubSpot</strong></td>
                        <td>CRM, marketing automation</td>
                        <td>Contact information, sales data</td>
                        <td>USA, EU</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Salesforce</strong></td>
                        <td>Customer relationship management</td>
                        <td>Customer profiles, sales pipeline</td>
                        <td>USA, EU, Asia</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Marketo (Adobe)</strong></td>
                        <td>Marketing automation</td>
                        <td>Lead data, campaign metrics</td>
                        <td>USA, EU</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>LinkedIn Sales Navigator</strong></td>
                        <td>Sales intelligence</td>
                        <td>Professional profiles, company data</td>
                        <td>USA</td>
                        <td>SOC 2</td>
                    </tr>
                </table>

                <h2>Legal and Compliance</h2>
                <table>
                    <tr>
                        <th>Subprocessor</th>
                        <th>Purpose</th>
                        <th>Data Processed</th>
                        <th>Location</th>
                        <th>Certifications</th>
                    </tr>
                    <tr>
                        <td><strong>DocuSign</strong></td>
                        <td>Electronic signatures</td>
                        <td>Contracts, signatory information</td>
                        <td>USA, EU</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>OneTrust</strong></td>
                        <td>Privacy management platform</td>
                        <td>Consent records, privacy preferences</td>
                        <td>USA, EU</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Ironclad</strong></td>
                        <td>Contract lifecycle management</td>
                        <td>Legal agreements, contract data</td>
                        <td>USA</td>
                        <td>SOC 2</td>
                    </tr>
                </table>

                <h2>Backup and Disaster Recovery</h2>
                <table>
                    <tr>
                        <th>Subprocessor</th>
                        <th>Purpose</th>
                        <th>Data Processed</th>
                        <th>Location</th>
                        <th>Certifications</th>
                    </tr>
                    <tr>
                        <td><strong>Veeam</strong></td>
                        <td>Backup management</td>
                        <td>System backups, configurations</td>
                        <td>Switzerland, USA</td>
                        <td>ISO 27001, SOC 2</td>
                    </tr>
                    <tr>
                        <td><strong>Acronis</strong></td>
                        <td>Disaster recovery</td>
                        <td>System images, backup data</td>
                        <td>Switzerland, EU</td>
                        <td>ISO 27001, SOC 2</td>
                    </tr>
                    <tr>
                        <td><strong>AWS Backup</strong></td>
                        <td>Cloud-native backup service</td>
                        <td>Database backups, file storage</td>
                        <td>Multiple AWS regions</td>
                        <td>Inherits AWS certifications</td>
                    </tr>
                </table>

                <h2>Human Resources and Internal Operations</h2>
                <table>
                    <tr>
                        <th>Subprocessor</th>
                        <th>Purpose</th>
                        <th>Data Processed</th>
                        <th>Location</th>
                        <th>Certifications</th>
                    </tr>
                    <tr>
                        <td><strong>Workday</strong></td>
                        <td>HR management system</td>
                        <td>Employee data (may process customer data indirectly)</td>
                        <td>USA</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>BambooHR</strong></td>
                        <td>HR information system</td>
                        <td>Employee records</td>
                        <td>USA</td>
                        <td>SOC 2</td>
                    </tr>
                    <tr>
                        <td><strong>Gusto</strong></td>
                        <td>Payroll processing</td>
                        <td>Employee payment data</td>
                        <td>USA</td>
                        <td>SOC 2</td>
                    </tr>
                </table>

                <h2>Professional Services Partners</h2>
                <table>
                    <tr>
                        <th>Subprocessor</th>
                        <th>Purpose</th>
                        <th>Data Processed</th>
                        <th>Location</th>
                        <th>Certifications</th>
                    </tr>
                    <tr>
                        <td><strong>Deloitte</strong></td>
                        <td>Security audits, compliance consulting</td>
                        <td>Audit logs, compliance documentation</td>
                        <td>Global</td>
                        <td>ISO 27001, SOC</td>
                    </tr>
                    <tr>
                        <td><strong>PwC</strong></td>
                        <td>Tax and financial audit services</td>
                        <td>Financial records, transaction data</td>
                        <td>Global</td>
                        <td>ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>External Legal Counsel</strong></td>
                        <td>Legal services</td>
                        <td>Case-specific data as required</td>
                        <td>Various</td>
                        <td>Professional liability insurance</td>
                    </tr>
                </table>

                <h2>Content Delivery and Media Services</h2>
                <table>
                    <tr>
                        <th>Subprocessor</th>
                        <th>Purpose</th>
                        <th>Data Processed</th>
                        <th>Location</th>
                        <th>Certifications</th>
                    </tr>
                    <tr>
                        <td><strong>Fastly</strong></td>
                        <td>CDN, edge computing</td>
                        <td>Cached content, request logs</td>
                        <td>Global</td>
                        <td>SOC 2, PCI DSS</td>
                    </tr>
                    <tr>
                        <td><strong>Akamai</strong></td>
                        <td>CDN, web performance</td>
                        <td>Static assets, traffic data</td>
                        <td>Global</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                    <tr>
                        <td><strong>Cloudinary</strong></td>
                        <td>Image and video management</td>
                        <td>Media files, metadata</td>
                        <td>USA, EU</td>
                        <td>SOC 2, ISO 27001</td>
                    </tr>
                </table>

                <h2>Additional Information</h2>

                <h3>Data Processing Agreements</h3>
                <p>We maintain executed Data Processing Agreements (DPAs) with all subprocessors listed above. These agreements ensure that:</p>
                <ul>
                    <li>Subprocessors only process data according to our instructions</li>
                    <li>Appropriate technical and organizational measures are implemented</li>
                    <li>Data subject rights are respected</li>
                    <li>International data transfers comply with applicable laws</li>
                    <li>Breach notification procedures are in place</li>
                </ul>

                <h3>Security Standards</h3>
                <p>All subprocessors are required to maintain minimum security standards including:</p>
                <ul>
                    <li>Encryption of data in transit and at rest</li>
                    <li>Access controls and authentication measures</li>
                    <li>Regular security audits and assessments</li>
                    <li>Incident response procedures</li>
                    <li>Employee background checks and training</li>
                    <li>Physical security for data centers</li>
                </ul>

                <h3>Due Diligence Process</h3>
                <p>Before engaging any new subprocessor, we conduct thorough due diligence including:</p>
                <ul>
                    <li>Security questionnaire and risk assessment</li>
                    <li>Review of compliance certifications</li>
                    <li>Data protection impact assessment (DPIA)</li>
                    <li>Financial stability verification</li>
                    <li>Reference checks from existing customers</li>
                    <li>Technical security review</li>
                </ul>

                <h3>Auditing and Monitoring</h3>
                <p>We continuously monitor our subprocessors through:</p>
                <ul>
                    <li>Annual security reviews</li>
                    <li>Quarterly compliance checks</li>
                    <li>Real-time performance monitoring</li>
                    <li>Incident report reviews</li>
                    <li>Certification renewal tracking</li>
                </ul>

                <h2>Your Rights and Options</h2>

                <h3>Objection Process</h3>
                <p>If you have concerns about a new subprocessor:</p>
                <ol>
                    <li>Submit objections to privacy@intellommerce.ai within 14 days of notification</li>
                    <li>Include specific concerns and requirements</li>
                    <li>We will work to address concerns or provide alternatives</li>
                    <li>If resolution isn't possible, contract termination rights may apply</li>
                </ol>

                <h3>Data Localization Options</h3>
                <p>Enterprise customers may request:</p>
                <ul>
                    <li>Geographic restrictions on data processing</li>
                    <li>Exclusion of specific subprocessors</li>
                    <li>Use of alternative subprocessors in specific regions</li>
                    <li>Custom deployment options</li>
                </ul>

                <h3>Transparency Reports</h3>
                <p>We provide:</p>
                <ul>
                    <li>Quarterly updates on subprocessor changes</li>
                    <li>Annual security assessment summaries</li>
                    <li>Incident reports affecting subprocessors</li>
                    <li>Compliance status updates</li>
                </ul>

                <h2>Special Categories</h2>

                <h3>Healthcare Data (HIPAA)</h3>
                <p>For customers processing healthcare data, only the following HIPAA-compliant subprocessors are used:</p>
                <ul>
                    <li>AWS (with signed BAA)</li>
                    <li>Microsoft Azure (with signed BAA)</li>
                    <li>Google Cloud Platform (with signed BAA)</li>
                    <li>Twilio (for HIPAA-compliant communications)</li>
                </ul>

                <h3>Financial Services</h3>
                <p>For financial services customers, enhanced controls apply:</p>
                <ul>
                    <li>PCI DSS Level 1 compliance required</li>
                    <li>Additional encryption requirements</li>
                    <li>Restricted geographic processing</li>
                    <li>Enhanced audit rights</li>
                </ul>

                <h3>Government and Public Sector</h3>
                <p>Government customers may utilize:</p>
                <ul>
                    <li>FedRAMP-authorized cloud providers only</li>
                    <li>Domestic-only processing options</li>
                    <li>Enhanced background check requirements</li>
                    <li>Compliance with specific regulatory frameworks</li>
                </ul>

                <h2>Emergency Subprocessors</h2>
                <p>In emergency situations (security incidents, service outages), we may engage temporary subprocessors:</p>
                <ul>
                    <li>Incident response firms</li>
                    <li>Forensic analysis services</li>
                    <li>Emergency infrastructure providers</li>
                    <li>Notification sent within 72 hours</li>
                    <li>Limited to emergency duration</li>
                </ul>

                <h2>Frequently Asked Questions</h2>

                <h3>Q: How often is this list updated?</h3>
                <p>A: We review and update this list monthly, with immediate updates for any additions or removals.</p>

                <h3>Q: Can I request removal of a specific subprocessor?</h3>
                <p>A: Enterprise customers can discuss alternatives during contract negotiations. Some core infrastructure providers cannot be removed.</p>

                <h3>Q: What happens to my data when a subprocessor is removed?</h3>
                <p>A: We ensure secure data migration and certified deletion from the removed subprocessor's systems within 30 days.</p>

                <h3>Q: Are subprocessors allowed to use sub-subprocessors?</h3>
                <p>A: Only with our explicit written approval and under the same contractual obligations.</p>

                <h3>Q: How do you handle subprocessors in restricted countries?</h3>
                <p>A: We maintain a list of approved countries and do not engage subprocessors in jurisdictions subject to data transfer restrictions without appropriate safeguards.</p>

                <h2>Contact Information</h2>
                <p>For questions about our subprocessors or to exercise your rights:</p>
                <ul>
                    <li><strong>Privacy Team:</strong> privacy@intellommerce.ai</li>
                    <li><strong>Data Protection Officer:</strong> dpo@intellommerce.ai</li>
                    <li><strong>Legal Department:</strong> legal@intellommerce.ai</li>
                    <li><strong>Enterprise Support:</strong> enterprise@intellommerce.ai</li>
                </ul>

                <h2>Document Information</h2>
                <ul>
                    <li><strong>Version:</strong> 3.2</li>
                    <li><strong>Last Review Date:</strong> Sat 23 Aug, 2025</li>
                    <li><strong>Next Review Date:</strong> Sat 20 Sep, 2025</li>
                    <li><strong>Document Owner:</strong> Data Protection Officer</li>
                    <li><strong>Approval:</strong> Chief Privacy Officer</li>
                </ul>
                {/**
                <h2>Changelog</h2>
                <table>
                    <tr>
                        <th>Date</th>
                        <th>Version</th>
                        <th>Changes</th>
                        <th>Approved By</th>
                    </tr>
                    <tr>
                        <td>[Date]</td>
                        <td>3.2</td>
                        <td>Added Datadog for monitoring; Removed legacy analytics provider</td>
                        <td>DPO</td>
                    </tr>
                    <tr>
                        <td>[Date]</td>
                        <td>3.1</td>
                        <td>Updated AWS regions; Added Cloudflare Workers locations</td>
                        <td>DPO</td>
                    </tr>
                    <tr>
                        <td>[Date]</td>
                        <td>3.0</td>
                        <td>Major update: Added 15 new subprocessors for expanded services</td>
                        <td>CPO</td>
                    </tr>
                </table>
                    **/}

                <p><em>This subprocessor list is provided for transparency and compliance purposes. It represents our current data processing arrangements and is subject to change as our business evolves. We are committed to maintaining the highest standards of data protection throughout our supply chain.</em></p>

            </div>
        </div>
    );
};

export default Subprocessors;